import { render, staticRenderFns } from "./SocialPostShareUrl.vue?vue&type=template&id=2a0ff61f&scoped=true&"
import script from "./SocialPostShareUrl.vue?vue&type=script&lang=js&"
export * from "./SocialPostShareUrl.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostShareUrl.vue?vue&type=style&index=0&id=2a0ff61f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ff61f",
  null
  
)

export default component.exports